module.exports = __webpack_public_path__ + "img/image 61.3b117529.svg";